import './BrokerModal.scss'

import React, {Component} from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import ConfirmButton from 'common/views/atoms/ConfirmButton/ConfirmButton'
import { editAdminRole } from "broker/redux/account";
import {BROKER_CONTACT_TYPES_DISPLAY} from "common/constants";

class ConfirmEditAdminRole extends Component {
  handleClick = () => {
    const { requested_role, broker_user_id, dispatch, handleHide } = this.props
    dispatch(editAdminRole(requested_role, broker_user_id))
    .then(handleHide)
  }

  render() {
    const { admin_name, current_role, requested_role} = this.props
    return (
      <Modal className="BrokerModal" show={this.props.show}>
        <Modal.Header>
          <Modal.Title>Edit Admin Role?</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text">
            Are you sure you want to edit { admin_name }&#39;s admin role from {BROKER_CONTACT_TYPES_DISPLAY[current_role]} to {BROKER_CONTACT_TYPES_DISPLAY[requested_role]}?
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="pull-right" onClick={this.props.handleHide}>Cancel</Button>
          <div className="pull-right btn-pad-right">
            <ConfirmButton
              onSubmit={this.handleClick}
              onFinish={this.props.handleHide}
              timeouts={2000}
              initialText="Yes"
              pendingText="Sending"
              completeText="Sent" />
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const ConfirmEditAdminRoleModal = connectModal({ name: 'ConfirmEditAdminRoleModal', destroyOnHide: false })(ConfirmEditAdminRole)

export default ConfirmEditAdminRoleModal
